module.exports = __webpack_public_path__ + "static/media/st3NytScreen.2f183778.jpg";